module.exports = "/static/assets/fb415ad5942786875408478a005153c2.gif";